export default __webpack_public_path__ + "img/filter_LM.dc50d9e6ee1e6fc2a28f1c5de443c339.jpg";